"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSofa = function SvgSofa(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12h3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1zm11 0h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.634 9.103a1.4 1.4 0 0 0 .79-1.267l.007-.28a1.52 1.52 0 0 1 1.502-1.397c.834 0 1.51.689 1.51 1.538 0 .849-.676 1.537-1.51 1.537a1.5 1.5 0 0 1-.137-.006v1.683c0 .772-.614 1.398-1.371 1.398H3.545c-.757 0-1.371-.626-1.371-1.398V9.228a1.5 1.5 0 0 1-.137.006c-.833 0-1.509-.688-1.509-1.537 0-.85.676-1.538 1.509-1.538A1.52 1.52 0 0 1 3.54 7.557l.006.28a1.4 1.4 0 0 0 .864 1.299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.513 6.252V4.14C2.32 1.396 3.693.023 6.63.023h9.613c2.184.117 3.276 1.49 3.276 4.118v1.577"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 5.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 8.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 13.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 4.5,
    y: 7.5,
    width: 6,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 11.5,
    y: 7.5,
    width: 6,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    transform: "rotate(40 16 5)",
    x: 14.5,
    y: 3.5,
    width: 3,
    height: 3,
    rx: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSofa);
var _default = exports["default"] = Memo;